declare global {
  var M2M_COMPONENTS_ENV: string;
  var M2M_STORAGE: import("./storage/client").M2mStorageClient | undefined;
}

export {};
